import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HandoffInfo } from 'src/app/common/models/handoffInfo';
import { AuthManager } from 'src/app/core/auth/auth.manager';
import { FacilityManager } from 'src/app/managers/facility.manager';

import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'facility-selection',
  templateUrl: './facility-selection.component.html',
  styleUrls: ['./facility-selection.component.scss'],
  standalone: true,
  imports: [MatFormField, MatLabel, MatSelect, MatOption, MatProgressSpinner],
})
export class FacilitySelectionComponent implements OnInit, OnDestroy {
  public selectedFacility: any;
  public facilities: HandoffInfo[] = [];
  public errorMessage: any;
  public facilitiesLoaded = false;
  public isAuthed = false;
  public isStoreUser = false;

  private _isSetup = false;
  private _subscriptions: Subscription[] = [];

  constructor(
    private facilityManager: FacilityManager,
    private authManager: AuthManager,
  ) {
    const facilidyIdUpdateSubscription = this.facilityManager.facilityIdUpdates$.subscribe({
      next: (fId) => {
        this.facilities = this.facilityManager.storeHandoffInfo();
        this.selectedFacility = fId;
      },
    });
    this._subscriptions.push(facilidyIdUpdateSubscription);
  }

  public ngOnInit(): void {
    this.facilityManager.facilitiesLoaded$.subscribe({
      next: (isReady) => {
        this.facilitiesLoaded = isReady;
        if (this.isAuthed && this.facilitiesLoaded && !this._isSetup) {
          this.setupDropdown();
        }
      },
    });

    this.authManager.isLoggedIn$.subscribe((isAuthed) => {
      this.isAuthed = isAuthed;
      if (this.isAuthed && this.facilitiesLoaded && !this._isSetup) {
        this.setupDropdown();
      }
    });
  }

  private setupDropdown(): void {
    this.isStoreUser = this.authManager.isStoreUser();
    this.facilities = this.facilityManager.storeHandoffInfo();
    this.selectedFacility = this.facilityManager.getCurrentFacility();
    this._isSetup = true;
  }

  public updateFacilitySelected(): void {
    this.facilityManager.setCurrentFacility(this.selectedFacility);
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach((s) => {
      s.unsubscribe();
    });
  }
}
